import { createTheme } from '@material-ui/core/styles';

export const IBT_THEME = createTheme({
  palette: {
    primary: {
      main:         '#066697',
      dark:         '#003C69',
      light:        '#4F94C8',
      background:   '#06669714',
      border:       '#06669780',
      coloredText:  '#205382',
      link:         '#205382',
    },
    secondary: {
      main:         '#FF505F',
      dark:         '#B23842',
      light:        '#FF737F',
      background:   '#FF505F14',
      border:       '#FF505F80',
    },
  },
});

export const MAZOOMA_THEME = createTheme({
  palette: {
    primary: {
      main:         '#066697',
      dark:         '#003C69',
      light:        '#4F94C8',
      text:         '#066697',
    },
    secondary: {
      main:         '#00BCE4',
      dark:         '#00839F',
      light:        '#33C9E9',
      text:         '#00839F',
    },
  },
});

export const INTERAC_THEME = createTheme({
  palette: {
    primary: {
      main:         '#07AFE0',
      dark:         '#0080AE',
      light:        '#4FC8EC',
      background:   '#07AFE014',
      border:       '#07AFE080',
      coloredText:  '#205382',
      link:         '#0080AE',
    },
    secondary: {
      main:         '#FF505F',
      dark:         '#B23842',
      light:        '#FF737F',
      background:   '#FF505F14',
      border:       '#FF505F80',
    },
  },
});

export const INTERAC_R_THEME = createTheme({
  palette: {
    primary: {
      main:         '#FFB92A',
      dark:         '#E5A626',
      light:        '#FFC651',
      text:         '#E5A626',
    }
  },
});
